import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordGrievance, EmploymentRecordGrievanceSubmit } from '../models/employment-record-grievance.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordGrievancesService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getGrievances(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Grievance`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            grievances: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getGrievance(employeeId: string, employmentRecordId: string, grievanceId: string): Observable<EmploymentRecordGrievance> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Grievance/${grievanceId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postGrievance(employeeId: string, employmentRecordId: string, grievance: EmploymentRecordGrievanceSubmit): Observable<EmploymentRecordGrievance> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Grievance`, grievance, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteGrievance(employeeId: string, employmentRecordId: string, grievanceId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Grievance/${grievanceId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

